import { Box, Button } from '@mui/material';
import dayjs from 'dayjs';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useMemo } from 'react';
import { useScreenWidth } from 'webHooks/useScreenWidth';
import styled from 'styled-components';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';


interface Props {
  currYear: number;
  currMonth: number;
  showNextButton: boolean;
  showPreviousButton: boolean;
  increaseNumMonths: () => void;
  onMonthChange: (date: Date) => void;
  onNextClick: () => void;
}

export const StyledBox = styled(Box)`
  padding: ${props => props.theme.spacing(2)};
  padding-top: 0px;
  background-color: ${props => props.theme.palette.grey[50]};
  border-bottom: 1px solid ${props => props.theme.palette.grey[300]};
  display: flex;
  justify-content: space-between;
  display: none;  

  ${props => props.theme.breakpoints.only('sm')} {
    display: flex;
  }



  & div {
    min-width: 50%;
  }

  & button {
    background-color: #fff;

    &:first-child {
      margin-right: 8px;
    }

    &:last-child {
      margin-left: 8px;
    }
  }

  ${props => props.theme.breakpoints.down('sm')} {
    background-color: #fff;
    margin-top: ${props => props.theme.spacing(2)};
    border-bottom: 1px solid transparent;
  }
`;

export const MonthControl = styled(Box)`
color: ${props => props.theme.palette.secondary.main};
height: calc(100% - 54px);
position: absolute;
display: flex;
align-items: center;
justify-content: center;
transition: all 0.2s;

& svg {
  font-size: ${props => props.theme.spacing(10)};  
  transition: all 0.2s;
  cursor: pointer;

  &:active, &:focus {
    color: ${props => props.theme.palette.secondary.dark};
  }
}

&.previous {
  left: 0px;
  padding-left: ${props => props.theme.spacing(3)};
}

&.next {
  right: 0px;
  padding-right: ${props => props.theme.spacing(1)};
}

${props => props.theme.breakpoints.down('md')} {
  display: none;
}
`;


export const DateRangePickerNavbar = ({
  currYear,
  currMonth,
  showNextButton,
  showPreviousButton,
  increaseNumMonths,
  onMonthChange,
  onNextClick,
}: Props) => {
  const { isXs } = useScreenWidth();

  const backButtonText = useMemo(() => {
    if (!isXs) return 'Previous';
    if (!showPreviousButton) return 'No More Dates to Load';
    return 'Show Previous Dates';
  }, [isXs, showPreviousButton]);

  return (
    <>
      <StyledBox>
        {showPreviousButton ? (
          <Button
            onClick={() => {
              const date = dayjs()
                .year(currYear)
                .month(currMonth - 1)
                .subtract(2, 'months');
              onMonthChange(date.toDate());
              if (isXs) increaseNumMonths();
            }}
            disabled={!showPreviousButton}
            variant={'outlined'}
            fullWidth
            color="secondary"
            startIcon={<ChevronLeftIcon />}
          >
            {backButtonText}
          </Button>
        ) : <Box></Box>}

        {!isXs ? (
          <Button
            variant="outlined"
            onClick={() => onNextClick()}
            disabled={!showNextButton}
            color="secondary"
            fullWidth
            endIcon={<ChevronRightIcon />}
          >
            Next
          </Button>
        ) : null}
      </StyledBox>

      {showPreviousButton ? (
        <MonthControl className="previous" onClick={() => {
          const date = dayjs()
            .year(currYear)
            .month(currMonth - 1)
            .subtract(2, 'months');
          onMonthChange(date.toDate());
          if (isXs) increaseNumMonths();
        }}>
          <ArrowBackIosIcon />
        </MonthControl>
      ) : null}
      <MonthControl className="next" onClick={() => onNextClick()}>
        <ArrowForwardIosIcon />
      </MonthControl>

    </>

  );
};
